import axios from 'axios'

console.log(this)
export const proxy = '/api'

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(proxy + url, {
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(proxy + url, data)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/simpleapi.js